// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.

import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

// https://vite.dev/guide/features#glob-import
const baseComponents = import.meta.glob(
    // Only "_base-" prefixed .vue files in this directory, not in subdirectories
    './_base-*.vue',
    { eager: true }
)

// For each matching file name...
Object.entries(baseComponents).forEach(([fileName, componentConfig]) => {
    // Get the PascalCase version of the component name
    const componentName = upperFirst(
        camelCase(
            fileName
                // Remove the "./_" from the beginning
                .replace(/^\.\/_/, '')
                // Remove the file extension from the end
                .replace(/\.\w+$/, '')
        )
    )
    // Globally register the component
    Vue.component(componentName, componentConfig.default || componentConfig)
})
